import React from 'react';
import axios from 'axios';
import { createGlobalStyle } from 'styled-components';
import Head from './Head';
import LocationList from './LocationList';
import SingleLocation from './SingleLocation';
import queryString from 'query-string';

const qs = queryString.parse(window.location.search);

export default function App() {
  const [location, setLocation] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [cityOptions, setCityOptions] = React.useState([]);
  const [filter, setFilter] = React.useState({
    city: null,
    type: null,
    format: null,
  });

  React.useEffect(() => {
    async function load() {
      let result = await axios('/api/totem/city/');
      let data = result.data.filter((d) => d.location != null);
      let locId = parseInt(qs.id);
      data.forEach((d) => {
        d.location = [d.location[1], d.location[0]];
        d.totems.forEach((t) => {
          t.location = [t.location[1], t.location[0]];
          t.city_name = d.name;
          if (t.totem_id === locId) setLocation(t);
        });
        d.totems = d.totems.filter(t => t.is_installed);
      });
      setData(data);
      let cityOptions = [
        { value: null, label: 'Svi gradovi' },
        ...data.map((c) => ({ value: c.city_id, label: c.name })),
      ];
      setCityOptions(cityOptions);
    }
    load();
  }, []);

  React.useEffect(() => {
    let f = e => {
      const qs = queryString.parse(window.location.search);
      let id = parseInt(qs.id);
      if (isNaN(id) || !isFinite(id)) return setLocation(null);
      data.forEach(d => {
        d.totems.forEach(t => {
          if (t.totem_id === id) setLocation(t);
        });
      });
    };
    window.addEventListener('popstate', f);
    return () => {
      window.removeEventListener('popstate', f);
    };
  }, [data]);

  function setLocationAndUrl(l) {
    setLocation(l);
    if (l == null) {
      window.history.pushState(null, null, '/locations/');
    } else {
      window.history.pushState(null, null, `/locations/?id=${l.totem_id}`);
    }
  }

  return (
    <>
      <GlobalStyle />
      {location == null && (
        <>
          <Head
            data={data}
            cityOptions={cityOptions}
            filter={filter}
            setFilter={setFilter}
            setLocation={setLocationAndUrl}
          />
          <LocationList
            data={data}
            filter={filter}
            setFilter={setFilter}
            setLocation={setLocationAndUrl}
          />
        </>
      )}

      {location != null && (
        <>
          <SingleLocation location={location} setLocation={setLocationAndUrl} />
        </>
      )}
    </>
  );
}

const GlobalStyle = createGlobalStyle`
  .mapboxgl-ctrl {
    display: none !important;
  }

  @media (min-height: 600px) {
    body {
      display: flex;
      flex-direction: column;
    }

    #root {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
`;
